<!-- 打印机管理 -->
<template>
  <div>
    <!-- 筛选项 -->
    <div class="search-box">
      <div class="d-flex top">
        <!-- 打印机编号： -->
        <span>打印机编号</span>
        <el-input size="small" class="width-340" v-model="queryParams.number" :placeholder="`请输入`" clearable></el-input>
      </div>
      <div class="d-flex top">
        <!-- 状态： -->
        <span>状态</span>
        <el-select class="width-340" size="small" v-model="queryParams.status" :placeholder="`请选择`" clearable>
          <el-option :label="`未激活`" value="0"></el-option>
          <el-option :label="`已激活`" value="1"></el-option>
        </el-select>
      </div>
      <div class="d-flex top">
        <!-- 租户： -->
        <span>租户</span>
        <tenantSelection style="display: inline-block;" class="width-340" @clickTenant="getTenantInfo" :data="tenantData" @inputClear="inputClear"></tenantSelection>
        <!-- <el-cascader
            class="width-340"
            size="small"
            clearable
            :before-filter="remoteSearch"
            filterable
            :options="address"
            :show-all-levels="false"
            v-model="queryParams.tenant_id"
            :props="{
              label: 'name',
              value: 'code',
              emitPath:false
            }"
            popper-class="cascader-style"
            @expand-change="expandChange"
            >
          </el-cascader> -->
        <!-- <el-select class="width-340" size="small" v-model="queryParams.tenant_id" :placeholder="`请选择`" clearable>
          <el-option v-for="item in tenantOpts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select> -->
      </div>
      <div class="d-flex top">
        <!-- 租户状态 -->
        <span>租户状态</span>
        <el-select
          class="width-340" 
          size="small" 
          v-model="queryParams.tenant_status" 
          :placeholder="`请选择`" 
          clearable>
          <el-option :label="`冻结`" value="2"></el-option>
          <el-option :label="`正常`" value="1"></el-option>
        </el-select>
      </div>
      <div class="d-flex top">
        <!-- 用户 -->
        <span>用户</span>
        <el-select
          class="width-340" 
          size="small" 
          v-model="queryParams.user_id" 
          :placeholder="`请选择`"
          filterable
          remote
          :remote-method="getPrintUserOpts"
          @focus="getPrintUserOpts()"
          clearable>
          <el-option v-for="item in userOpts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
      <div class="d-flex top">
        <!-- 创建时间： -->
        <span>创建时间</span>
        <el-date-picker class="width-340" size="small" v-model="queryParams.createdTime" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`"> </el-date-picker>
      </div>
      <div class="d-flex top">
        <!-- 激活时间： -->
        <span>激活时间</span>
        <el-date-picker class="width-340" size="small" v-model="queryParams.activateTime" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`"> </el-date-picker>
      </div>
      <div class="d-flex top">
        <!-- 蓝牙地址： -->
        <span>蓝牙地址</span>
        <el-input size="small" class="width-340" v-model="queryParams.bluetooth_address" :placeholder="`请输入`" clearable></el-input>
      </div>
      <div class="d-flex top">
        <!-- 序列号： -->
        <span>机器序列号</span>
        <el-input size="small" class="width-340" v-model="queryParams.serial_number" :placeholder="`请输入`" clearable></el-input>
      </div>
      <div style="">
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="mt10 search-line">
      <div>
        <el-button size="small" class="no-border" type="primary" @click="openDialog(`新建打印机`, 'newPrinter')">新建</el-button>

        <el-button size="small" class="ml10 no-border" style="background-color: rgb(255, 68, 68)" type="primary" @click="batchDeletion">批量删除</el-button>
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(255, 151, 106)" type="primary" @click="importList()">导入</el-button>
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(194, 128, 255)" type="primary" @click="batchResetTenants">批量重置租户</el-button>
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(7, 193, 96)" type="primary" @click="summaryStatistics">汇总统计</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      class="mt10" 
      ref="multipleTable" 
      border 
      :data="list"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="#" width="55"></el-table-column>
      <el-table-column
        v-for="item in columns" 
        :label="item.text" 
        :key="item.column" 
        :width="item.width"
        :sortable="!!item.order_column ? 'custom': false"
        :sort-by="item.order_column"
        >
        <template slot-scope="scope">
          <!-- 操作 -->
          <template v-if="item.column == 'handle'">
            <el-button type="text" @click="viewByList(scope.row)" >
                查看
            </el-button>
            <el-button type="text" @click="openDialog(`修改打印机`, 'editPrinter', scope.row)">
                修改
            </el-button>
            <el-button type="text" @click="deleteByList(scope.row)">
                删除
            </el-button>
            <el-button type="text" @click="resetByList(scope.row)">
                重置租戶
            </el-button>
          </template>
          <span v-else>{{ scope.row[item.column] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 新增弹框 -->
    <el-dialog @close="closeDialog" :title="dialogTitle" :visible.sync="dialogVisible" width="1200px">
      <el-form ref="dialogForm" :rules="dialogRules" :model="form" size="small" label-width="130px">
        <el-row v-show="functionType == 'newPrinter'">
          <el-col :span="6">
            <!-- 数量： -->
            <el-form-item :label="`数量` + '：'">
              <el-input-number :min="1" class="form-width" @change="changePrinter" v-model="printerNum"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 有效截止日期： -->
            <el-form-item :label="`有效截止日期` + '：'" prop="maintenance_expire_time">
              <el-date-picker class="form-width" v-model="form.maintenance_expire_time" type="date" value-format="yyyy-MM-dd" :placeholder="`选择日期`"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 生产厂商： -->
            <el-form-item :label="`生产厂商` + '：'">
              <el-select clearable filterable :disabled="functionType == 'editPrinter'" class="form-width" v-model="form.vendor" :placeholder="`请选择`">
                <el-option v-for="item in vendorList" :key="item.id" :label="item.name" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 品牌： -->
            <el-form-item :label="`品牌` + '：'">
              <el-select clearable filterable :disabled="functionType == 'editPrinter'" class="form-width" v-model="form.brand" :placeholder="`请选择`">
                <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 型号： -->
            <el-form-item :label="`型号` + '：'">
              <el-input :disabled="functionType == 'editPrinter'" class="form-width" v-model="form.model" :placeholder="`请输入`"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 规格： -->
            <el-form-item :label="`规格` + '：'">
              <el-input :disabled="functionType == 'editPrinter'" class="form-width" v-model="form.spec" :placeholder="`请输入`"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <div v-for="(item, index) in form.printer" :key="item.key" class="printer-details ml20">
          <span class="dialogNum">{{ index + 1 }}</span>
          <!-- 打印机编号 -->
          <el-form-item :label="`打印机编号` + '：'" :prop="'printer.' + index + '.number'" :rules="{ required: true, message: `打印机编号不能为空`, trigger: 'blur' }">
            <el-input :disabled="functionType == 'editPrinter'" class="PD-input-width" v-model="item.number" :placeholder="`请输入`"></el-input>
          </el-form-item>
          <!-- 蓝牙地址： -->
          <el-form-item
            :label="`蓝牙地址` + '：'"
            :prop="'printer.' + index + '.bluetooth_address'"
            :rules="[
              { required: true, message: `蓝牙地址不能为空`, trigger: 'blur' },
              { validator: validateBluetoothAddress, trigger: 'blur' },
            ]"
          >
            <el-input class="PD-input-width" v-model="item.bluetooth_address" :placeholder="`请输入`"></el-input>
          </el-form-item>
          <!-- 机器序列号： -->
          <el-form-item :label="`机器序列号` + '：'" :prop="'printer.' + index + '.serial_number'" :rules="{ required: true, message: `机器序列号不能为空`, trigger: 'blur' }">
            <el-input :disabled="functionType == 'editPrinter'" class="PD-input-width" v-model="item.serial_number" :placeholder="`请输入`"></el-input>
          </el-form-item>
          <i v-if="index != 0" @click="deletePrinter(index)" class="el-icon-delete ml15"></i>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogSubmitForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 激活统计 -->
    <el-dialog :title="`激活统计`" :visible.sync="dialogVisible2" width="1300px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="`按租户`" name="first">
          <!-- 按租户表格 -->
          <div class="search-line">
            <div class="flex-layout">
              <div class="ml10">
                <span>激活日期：</span>
                <el-date-picker v-model="tenantQueryParams.time" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`"> </el-date-picker>
              </div>
              <div class="ml10">
                <span>租户名称：</span>
                <el-select v-model="tenantQueryParams.tenant_id" :placeholder="`请选择`" clearable>
                  <el-option v-for="item in tenantOpts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <el-button class="ml10" type="primary" @click="searchPrinterStatisticsList">查询</el-button>
              <el-button class="ml10" type="primary" @click="getPrinterStatisticsList(1)">导出</el-button>
            </div>
          </div>
          <el-table class="mt10" border :data="tenantStatisticsList">
            <el-table-column type="index" label="#" width="55"></el-table-column>
            <el-table-column v-for="item in tenantStatisticsColumns" :label="item.text" :key="item.column" :width="item.width">
              <template slot-scope="scope">
                <!-- 操作 -->
                <template v-if="item.column == 'handle'">
                  <span class="operation" @click="viewByTenant(scope.row)">查看</span>
                </template>
                <span v-else>{{ scope.row[item.column] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination :queryParams="tenantQueryParams" :getList="getPrinterStatisticsList" />
        </el-tab-pane>
        <el-tab-pane :label="`按打印机编码`" name="second">
          <!-- 按打印机编码表格 -->
          <div class="search-line">
            <div class="flex-layout">
              <div class="ml10">
                <span>打印机编码创建日期：</span>
                <el-date-picker v-model="printerCodeQueryParams.time" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`"> </el-date-picker>
              </div>
            </div>
            <div>
              <el-button class="ml10" type="primary" @click="searchPrinterStatisticsList">查询</el-button>
              <el-button class="ml10" type="primary" @click="getPrinterStatisticsList(1)">导出</el-button>
            </div>
          </div>
          <el-table class="mt10" border :data="printerCodeStatisticsList">
            <el-table-column type="index" label="#" width="55"></el-table-column>
            <el-table-column v-for="item in printerCodeStatisticsColumns" :label="item.text" :key="item.column" :width="item.width">
              <template slot-scope="scope">
                <!-- 操作 -->
                <template v-if="item.column == 'handle'">
                  <span class="operation" @click="viewByTenant(scope.row)">查看</span>
                </template>
                <span v-else>{{ scope.row[item.column] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination :queryParams="printerCodeQueryParams" :getList="getPrinterStatisticsList" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 汇总统计中的的查看弹框 -->
    <el-dialog :title="`查看`" :visible.sync="dialogVisible4" width="1300px">
      <el-table class="mt10" border :data="viewDetailsList">
        <el-table-column type="index" label="#" width="55"></el-table-column>
        <el-table-column v-for="item in viewDetailsColumns" :label="item.text" :key="item.column" :width="item.width" :prop="item.column"> </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 查看列表打印机具体信息 -->
    <el-dialog :title="`查看`" :visible.sync="dialogVisible5" width="900px">
      <div class="list-view mb10">
        <span>租户：{{ listDetail.tenant_name }}</span>
        <span>生产厂商：{{ listDetail.vendor_name }}</span>
        <span></span>
      </div>
      <div class="list-view">
        <span>品牌：{{ listDetail.brand_name }}</span>
        <span>型号：{{ listDetail.model }}</span>
        <span>规格：{{ listDetail.spec }}</span>
      </div>
      <el-divider></el-divider>
      <div class="list-view">
        <span>打印机编号：{{ listDetail.number }}</span>
        <span>蓝牙地址：{{ listDetail.bluetooth_address }}</span>
        <span>机器序列号：{{ listDetail.serial_number }}</span>
      </div>
      <el-divider></el-divider>
      <div class="list-view">
        <span>创建时间：{{ listDetail.created_at }}</span>
        <span>激活时间：{{ listDetail.activate_time }}</span>
        <span>维保到期日：{{ listDetail.maintenance_expire_time }}</span>
      </div>
      <img :src="`${$utils.generateCode(listDetail.number, 'code128')}`" alt="" class="qr-code" />
    </el-dialog>

    <ImportFile :link="'/template/printer/' + `打印机编号管理` + '.xlsx'" ref="importFile" @complete="getImport" />
  </div>
</template>

<script>
import tenantSelection from '@/components/common/tenantSelection'
import ImportFile from '@/components/common/ImportFile.vue';
import { printer, getTenantOpts, printerDelete, printerReset, printerStatistics, printerStatisticsDetail, printerEdit, printerImport, printerSave, printerUser } from '@/api.js';
import { pageSize } from '@/utils/Config';
import Pagination from '@/components/common/Pagination';
import { mapGetters } from 'vuex'
export default {
  components: {
    Pagination,
    ImportFile,
    tenantSelection
  },
  computed: {
    ...mapGetters(['addressOptions']),
    // address(){
    //   // 区县下一级列表初始化
    //   let arr = this.$utils.deepCopy(this.addressOptions)
    //               // 避免重复做处理
    //               for (const item of arr) {
    //     item.code = item.code + 'code'
    //   }
    //   for (const province of arr) {
    //     for (const city of province.children) {
    //       for (const county of city.children) {
    //         this.$set(county,'children',[])
    //       }
    //     }
    //   }
    //   this.tenantOpts.forEach(item => {
    //     const province = arr.find(i => i.code === item.province + 'code')
    //     if (province) {
    //       const city = province.children.find(i => i.code === item.city)
    //       if (city) {
    //         const county = city.children.find(i => i.code === item.area)
    //         if (county) {
    //           county.children.push({
    //             name: item.name,
    //             code: item.id
    //           })
    //         }
    //       }
    //     }
    //   })
    //   return arr
    // }
  },
  data() {
    return {
      functionType: '',
      // 列表的查询条件
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      // 按租户的查询条件
      tenantQueryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      // 按打印机编码的查询条件
      printerCodeQueryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      list: [],
      columns: [],
      tenantOpts: [],
      tenantStatisticsList: [],
      tenantStatisticsColumns: [],
      printerCodeStatisticsList: [],
      printerCodeStatisticsColumns: [],
      viewDetailsList: [],
      viewDetailsColumns: [],
      dialogVisible: false, // 弹框显示与否
      dialogVisible2: false, // 激活统计的弹框显示与否
      dialogVisible4: false, // 汇总统计中的弹框显示与否
      dialogVisible5: false, // 查看列表打印机具体信息弹框显示与否
      dialogTitle: '',
      printerNum: 1,
      form: {
        vendor: '',
        brand: '',
        model: '',
        maintenance_expire_time: '',
        spec: '',
        printer: [
          {
            number: '',
            bluetooth_address: '',
            serial_number: '',
            key: Date.now(),
          },
        ],
      }, //表单
      dialogRules: {
        shippingArea: [
          // 发货区域
          { required: true, message: `请输入发货区域`, trigger: 'change' },
        ],
        maintenance_expire_time: [
          //截止日期
          {
            required: true,
            message: `请选择日期`,
            trigger: 'blur',
          },
        ],
      },
      listDetail: [],
      brandList: [],
      vendorList: [],
      activeName: 'first',
      multipleSelection: [],
      tenantData:{
        inputData:'',
        clearable:true,
        inputSize:'small'
      },
      userOpts: [],
    };
  },
  created() {
    this.getList();
    this.getTenantsOpts();

    this.$utils.getDict([605, 606]).then((res) => {
      if (res) {
        this.vendorList = res[605];
        this.brandList = res[606];
      }
    });
  },
  methods: {
    // 从子组件获取信息
    getTenantInfo(data){
      this.queryParams.tenant_id = data.id
      this.tenantData.inputData = data.name
    },
    // 当子组件清除内容时
    inputClear(){
      this.queryParams.tenant_id = ''
    },
    validateBluetoothAddress(rule, value, callback) {
      const bluetoothAddressPattern = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/; // 定义蓝牙地址的正则表达式
      if (!value) {
        callback(new Error(`蓝牙地址不能为空`));
      } else if (!bluetoothAddressPattern.test(value)) {
        callback(new Error(`请输入有效的蓝牙地址`));
      } else {
        callback(); // 校验通过
      }
    },
    // 获取列表数据
    getList() {
      const { pageIndex, pageSize, status, tenant_id, number, createdTime, activateTime, bluetooth_address, serial_number, tenant_status, user_id, order, orderBy } = this.queryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        status,
        number,
        tenant_id,
        created_start: createdTime ? createdTime[0] : undefined,
        created_end: createdTime ? createdTime[1] : undefined,
        activate_start: activateTime ? activateTime[0] : undefined,
        activate_end: activateTime ? activateTime[1] : undefined,
        bluetooth_address: bluetooth_address || undefined,
        serial_number: serial_number || undefined,
        tenant_status: tenant_status || undefined,
        user_id: user_id || undefined,
        order,
        order_column: orderBy
      };
      if (query.status === '') {
        delete query.status;
      }
      this.$request('get', printer, query).then((res) => {
        if (res) {
          this.list = res.data;
          this.columns = res.columns;
          this.queryParams._total = res.total;
        }
      });
    },

    // 获取租户
    getTenantsOpts(name = null , area = null , province = null , city = null) {
      return this.$request('get', getTenantOpts, { name,province,city,area })
      .then(res => {
        if(res){
          this.tenantOpts = res || []
        }
      })
    },

    // 获取打印用户
    getPrintUserOpts(name = undefined) {
      return this.$request('get', printerUser, { name })
      .then(res => {
        if(res){
          this.userOpts = res || []
        }
      })
    },

    // 搜索
    search() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },

    // 列表页的查看按钮
    viewByList(data) {
      this.dialogVisible5 = true;
      this.listDetail = data;
    },

    // 按租户区域的查看按钮
    viewByTenant(data) {
      let query = {};
      if (this.activeName == 'first') {
        query.type = 0;
        query.tenant_id = data.tenant_id;
        query.activate_date = data.activate_date;
      } else if (this.activeName == 'second') {
        query.type = 1;
        query.created_date = data.created_date;
      }
      this.$request('get', printerStatisticsDetail, query).then((res) => {
        if (res) {
          this.viewDetailsList = res.data;
          this.viewDetailsColumns = res.columns;
          this.dialogVisible4 = true;
        }
      });
    },

    // 批量重置租户
    batchResetTenants() {
      // 需要判断是否选中了数据
      if (this.multipleSelection.length == 0) {
        this.promptSelectingData(); // 提示选择数据
        return;
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        if (item.status == 1) {
          arr.push(item.id);
        }
      });
      if (arr.length == 0) {
        this.$message({
          message: `只能重置状态是已激活的打印机数据`,
          type: 'warning',
        });
        return;
      }
      this.$confirm(`是否确认重置租户`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.resetHttp(arr);
      });
    },

    // 列表中的重置用户
    resetByList(data) {
      if (data.status == 1) {
        this.$confirm(`是否确认重置租户`, `提示`, {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: 'warning',
        }).then(() => {
          this.resetHttp([data.id]);
        });
      } else {
        this.$message({
          message: `只能重置状态是已激活的打印机数据`,
          type: 'warning',
        });
      }
    },

    // 重置的方法
    resetHttp(ids) {
      this.$request('post', printerReset, {
        ids,
      }).then((res) => {
        if (res) {
          this.$message({
            type: 'success',
            message: `重置成功` + '!',
          });
          this.search();
        }
      });
    },

    //批量删除
    batchDeletion() {
      // 需要判断是否选中了数据
      if (this.multipleSelection.length == 0) {
        this.promptSelectingData(); // 提示选择数据
        return;
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        if (item.status == 0) {
          arr.push(item.id);
        }
      });
      if (arr.length == 0) {
        this.$message({
          message: `只能删除状态是未激活的打印机数据`,
          type: 'warning',
        });
        return;
      }
      this.$confirm(`是否确认删除`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.deleteHttp(arr);
      });
    },

    // 列表中的删除按钮
    deleteByList(data) {
      if (data.status == 0) {
        this.$confirm(`是否确认删除` + '?', `提示`, {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: 'warning',
        }).then(() => {
          this.deleteHttp([data.id]);
        });
      } else {
        this.$message({
          message: `只能删除状态是未激活的打印机数据`,
          type: 'warning',
        });
      }
    },

    // 删除的方法
    deleteHttp(ids) {
      this.$request('post', printerDelete, {
        ids,
      }).then((res) => {
        if (res) {
          this.$message({
            type: 'success',
            message: `删除成功` + '!',
          });
          this.search();
        }
      });
    },

    // 当弹框关闭时：
    closeDialog() {
      this.$refs.dialogForm.resetFields();
    },

    // 打开弹框
    openDialog(title, functionType, data) {
      this.form.printer = [];
      this.printerNum = 1;
      if (functionType == 'editPrinter') {
        if (data.status == 1) {
          // 如果是点击的修改，那么需要判断是否激活，只有未激活的数据才可以修改
          this.$message({
            message: `只能修改未激活的数据。`,
            type: 'warning',
          });
          return;
        }
        this.editId = data.id;
        this.form.maintenance_expire_time = data.maintenance_expire_time;
        this.form.vendor = data.vendor == 0 ? '' : data.vendor;
        this.form.brand = data.brand == 0 ? '' : data.brand;
        this.form.model = data.model == 0 ? '' : data.model;
        this.form.spec = data.spec == 0 ? '' : data.spec;
        this.form.printer = [
          {
            number: data.number,
            bluetooth_address: data.bluetooth_address,
            serial_number: data.serial_number,
          },
        ];
      } else if (functionType == 'newPrinter') {
        this.form.printer.push({
          number: '',
          bluetooth_address: '',
          serial_number: '',
          key: Date.now(),
        });
        this.$set(this.form, 'vendor', '');
        this.$set(this.form, 'brand', '');
        this.$set(this.form, 'model', '');
        this.$set(this.form, 'spec', '');
        this.$set(this.form, 'maintenance_expire_time', '');
      }
      this.dialogTitle = title;
      this.functionType = functionType;
      this.dialogVisible = true;
    },

    //提示选择数据
    promptSelectingData() {
      this.$message({
        message: `请选择数据`,
        type: 'warning',
      });
    },

    // 弹框中的提交
    dialogSubmitForm() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          var query = {};
          var url = '';
          if (this.functionType == 'newPrinter') {
            // 新增时的提交
            query = this.form;
            url = printerSave;
          } else if (this.functionType == 'editPrinter') {
            // 修改时的提交
            query.bluetooth_address = this.form.printer[0].bluetooth_address;
            url = printerEdit + this.editId;
          }
          this.$request('post', url, query).then((res) => {
            if (res) {
              this.search();
              this.dialogVisible = false;
              if(this.functionType == 'newPrinter'){
                this.$message.success(`新增成功`)
              }else if(this.functionType == 'editPrinter'){
                this.$message.success(`修改成功`)
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 弹框中数量变化时的改变：
    changePrinter(newVal) {
      if (this.form.printer.length < newVal) {
        // 数组长度小于目标长度，向数组末尾添加空对象直到长度达到目标值
        let val = 0;
        while (this.form.printer.length < newVal) {
          val += 1;
          this.form.printer.push({
            number: '',
            bluetooth_address: '',
            serial_number: '',
            key: Date.now() + val, //key的作用是用来在v-for的时候使用，加val是为了解决当输入框中直接输入某个数，生成的key是重复的。
          });
        }
      } else if (this.form.printer.length > newVal) {
        // 数组长度大于目标长度，移除数组末尾的元素直到长度等于目标值
        this.form.printer.splice(newVal);
      }
    },

    // 弹框中的删除打印机
    deletePrinter(index) {
      if (this.printerNum == 1) {
        // 当打印机只有一个的时候，不删除
        return;
      }
      this.printerNum -= 1;
      this.form.printer.splice(index, 1);
    },

    summaryStatistics() {
      this.dialogVisible2 = true;
      this.getPrinterStatisticsList();
    },

    // 按租户 tab页的搜索按钮
    searchPrinterStatisticsList() {
      if (this.activeName == 'first') {
        this.tenantQueryParams.pageIndex = 1;
      } else if (this.activeName == 'second') {
        this.printerCodeQueryParams.pageIndex = 1;
      }
      this.getPrinterStatisticsList();
    },

    // 获取打印机激活统计的数据
    getPrinterStatisticsList(is_export = 0) {
      var query = {};
      if (this.activeName == 'first') {
        const { pageIndex, pageSize, tenant_id, time } = this.tenantQueryParams;
        query = {
          type: 0,
          page: pageIndex,
          per_page: pageSize,
          tenant_id,
          activate_start: time ? time[0] : undefined,
          activate_end: time ? time[1] : undefined,
          is_export,
        };
      } else if (this.activeName == 'second') {
        const { pageIndex, pageSize, time } = this.printerCodeQueryParams;
        query = {
          type: 1,
          page: pageIndex,
          per_page: pageSize,
          created_start: time ? time[0] : undefined,
          created_end: time ? time[1] : undefined,
          is_export,
        };
      }
      if (is_export) {
        // 判断是不是点击的导出
        this.$utils.exportFile(printerStatistics, query);
        return;
      }
      this.$request('get', printerStatistics, query).then((res) => {
        if (res) {
          if (this.activeName == 'first') {
            // 如果是“按租户”
            this.tenantStatisticsList = res.data;
            this.tenantStatisticsColumns = res.columns;
            this.tenantQueryParams._total = res.total;
          } else if (this.activeName == 'second') {
            // 如果是“按打印机编码”
            this.printerCodeStatisticsList = res.data;
            this.printerCodeStatisticsColumns = res.columns;
            this.printerCodeQueryParams._total = res.total;
          }
        }
      });
    },

    // 当表格选择数据的时候
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'desc' : 'asc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },

    //切换tab页的时候：
    handleClick() {
      // 当切换tab页面时，如果没有数据的时候，需要加载数据
      if ((this.activeName == 'first' && this.tenantStatisticsList.length == 0) || (this.activeName == 'second' && this.printerCodeStatisticsList.length == 0)) {
        this.searchPrinterStatisticsList();
      }
    },

    // 开始导入
    importList() {
      this.$refs.importFile.show();
    },

    // 接收导入文件信息
    getImport(file) {
      const info = {
        file_id: file.fileId,
      };
      this.$request('post', printerImport, info).then((res) => {
        if (res) {
          // 导入成功
          this.$message.success(`导入成功`);
          this.search();
        }
      });
    },
    // async remoteSearch(value){
    //   let res = await this.$request('get', getTenantOpts, { name:value })
    //   this.tenantOpts = res || []
    // },
    // expandChange(node){
    //   if (node[2]) {
    //     this.getTenantsOpts(null,node[2])
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  display: grid;
  grid-template-columns: repeat(auto-fill, 440px);
  justify-content: space-between;
  row-gap: 10px;
}
.search-box > div {
  overflow: hidden;
}
.search-box > div > span {
  width: 96px;
  display: inline-block;
}
.flex-layout {
  display: flex;
}
.no-border {
  border: none;
}
.operation {
  color: #00afde;
  cursor: pointer;
}
.form-width {
  width: 160px;
}
.printer-details {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .el-form-item {
    margin-bottom: 0px;
  }
}
.PD-input-width {
  width: 220px;
}
.dialogNum {
  display: inline-block;
  width: 20px;
}
.activite-button {
  color: #00afde;
  border: 1px solid #00afde;
  background-color: #fff;
  text-align: center;
  line-height: 38px;
  padding: 0 20px;
  border-radius: 5px;
}
.list-view {
  display: flex;
  justify-content: space-around;
  span {
    display: inline-block;
    width: 250px;
  }
}
.qr-code {
  height: 60px;
  width: 200px;
  margin-top: 20px;
  margin-left: 20px;
}
.width-340 {
  width: 340px;
}
</style>
